/* ============================================================
   DosZenn, comportements de la boutique

   Règle du thème : aucun texte visible n’est écrit ici. Les
   libellés que ce script réinjecte dans le panier viennent de
   window.DosZen.strings, alimenté par layout/theme.liquid depuis
   Réglages du thème > Textes du panier. Les valeurs de repli ne
   servent que si un réglage a été vidé.

   Branché sur du vrai :
     panier via API Ajax Shopify (/cart/add.js, /cart/change.js,
     /cart.js), même rendu que le tiroir Liquid ; page produit avec
     vraies variantes et vrai formulaire produit.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.DosZen || {};
  var FREE_SHIPPING = typeof CFG.freeShippingThreshold === 'number' ? CFG.freeShippingThreshold : 4900;
  var SHIPPING_COST = typeof CFG.shippingCost === 'number' ? CFG.shippingCost : 490;
  var ROUTES = CFG.routes || {};
  var STR = CFG.strings || {};
  var CART_JSON = ROUTES.cartJson || '/cart.js';
  var CART_ADD = ROUTES.cartAdd || '/cart/add.js';
  var CART_CHANGE = ROUTES.cartChange || '/cart/change.js';

  var QUOT = String.fromCharCode(34);
  var APOS = String.fromCharCode(39);

  /* Libellé piloté par l’éditeur de thème, avec repli. */
  function s(key, fallback) {
    var v = STR[key];
    return (v === undefined || v === null || v === '') ? fallback : v;
  }

  /* ---------------- OUTILS ---------------- */

  function eur(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  var ESC_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;' };
  ESC_MAP[QUOT] = '&quot;';
  ESC_MAP[APOS] = '&#39;';
  var ESC_RE = new RegExp('[&<>' + QUOT + APOS + ']', 'g');

  function esc(str) {
    return String(str == null ? '' : str).replace(ESC_RE, function (c) { return ESC_MAP[c]; });
  }

  function thumbUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------- TOAST ---------------- */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 2600);
  }
  window.dosZenToast = toast;

  /* ---------------- REVEAL AU SCROLL ---------------- */
  var io;
  function reveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.rv').forEach(function (n) { n.classList.add('in'); });
      return;
    }
    if (io) io.disconnect();
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    $$('.rv').forEach(function (n) { io.observe(n); });
  }

  /* ---------------- HEADER COLLANT ---------------- */
  window.addEventListener('scroll', function () {
    var h = document.getElementById('hdr');
    if (h) h.classList.toggle('stuck', window.scrollY > 40);
  }, { passive: true });

  /* ---------------- BANDEAU ROTATIF ---------------- */
  var announceTimer;
  function startAnnounce() {
    clearInterval(announceTimer);
    var items = $$('.announce-item');
    if (items.length < 2) return;
    var i = 0;
    announceTimer = setInterval(function () {
      items[i].classList.remove('on');
      i = (i + 1) % items.length;
      items[i].classList.add('on');
    }, 4200);
  }

  /* ---------------- CARROUSEL ---------------- */
  function railScroll(id, dir) {
    var r = document.getElementById(id);
    if (!r) return;
    var first = r.querySelector('*');
    if (!first) return;
    r.scrollBy({ left: dir * (first.offsetWidth + 20), behavior: 'smooth' });
  }

  /* ---------------- TIROIR PANIER ---------------- */
  function openCart() {
    var d = document.getElementById('drawer'), o = document.getElementById('ov');
    if (d) { d.classList.add('on'); d.setAttribute('aria-hidden', 'false'); }
    if (o) o.classList.add('on');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    var d = document.getElementById('drawer'), o = document.getElementById('ov');
    if (d) { d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); }
    if (o) o.classList.remove('on');
    document.body.style.overflow = '';
  }

  function lineHTML(item) {
    var media = item.image
      ? '<div class="media"><img src="' + esc(thumbUrl(item.image, 180)) + '" alt="' + esc(item.product_title) + '" loading="lazy" width="74" height="93"></div>'
      : '<div class="ph"><span>' + esc(String(item.product_title || '').split(' ')[0]) + '</span></div>';

    var bits = [];
    if (item.variant_title && item.variant_title !== 'Default Title') bits.push(item.variant_title);
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        if (k.charAt(0) === '_') return;
        if (item.properties[k]) bits.push(k + ' : ' + item.properties[k]);
      });
    }

    return '<div class="line" data-key="' + esc(item.key) + '">' +
      media +
      '<div style="flex:1">' +
        '<h5><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></h5>' +
        '<div class="opt">' + esc(bits.join(', ')) + '</div>' +
        '<div style="display:flex;justify-content:space-between;align-items:center">' +
          '<span class="qty">' +
            '<button type="button" data-qty="-1" data-key="' + esc(item.key) + '" aria-label="' + esc(s('qtyMinus', 'Retirer un exemplaire')) + '">-</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-qty="1" data-key="' + esc(item.key) + '" aria-label="' + esc(s('qtyPlus', 'Ajouter un exemplaire')) + '">+</button>' +
          '</span>' +
          '<b>' + eur(item.final_line_price != null ? item.final_line_price : item.line_price) + '</b>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function emptyHTML() {
    return '<div class="empty"><p>' + esc(s('cartEmpty', 'Votre panier est vide.')) + '</p>' +
      '<a href="' + esc(CFG.productUrl || '/collections/all') + '" class="btn btn--sm" data-cart-close>' +
      esc(s('cartEmptyCta', 'Voir la boutique')) + '</a></div>';
  }

  function renderCart(cart) {
    var sub = cart.total_price;
    var shipCost = sub === 0 ? 0 : (sub >= FREE_SHIPPING ? 0 : SHIPPING_COST);
    var html = cart.items.length ? cart.items.map(lineHTML).join('') : emptyHTML();

    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });

    var body = document.getElementById('cartBody');
    if (body) body.innerHTML = html;

    var pageBody = document.getElementById('cartPage');
    if (pageBody) pageBody.innerHTML = html;

    var set = function (id, val) { var el = document.getElementById(id); if (el) el.textContent = val; };
    var shipLabel = sub === 0 ? '·' : (shipCost === 0 ? s('shipFree', 'Offerte') : eur(shipCost));
    set('sub', eur(sub));
    set('ship', shipLabel);
    set('total', eur(sub + shipCost));
    set('pgSub', eur(sub));
    set('pgShip', shipLabel);
    set('pgTotal', eur(sub + shipCost));

    var fill = document.getElementById('shipFill');
    if (fill) fill.style.width = Math.min(100, sub / FREE_SHIPPING * 100) + '%';

    var msg = document.getElementById('shipMsg');
    if (msg) {
      msg.textContent = sub >= FREE_SHIPPING
        ? s('freeReached', 'Livraison offerte')
        : s('freePrefix', 'Plus que') + ' ' + eur(FREE_SHIPPING - sub) + ' ' + s('freeSuffix', 'pour la livraison offerte');
    }

    $$('[data-checkout]').forEach(function (b) { b.disabled = cart.items.length === 0; });
  }

  function getCart() {
    return fetch(CART_JSON, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(formData) {
    return fetch(CART_ADD, { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data.description || res.data.message || s('addFailed', 'Ajout impossible'));
          return null;
        }
        return getCart().then(function (cart) {
          openCart();
          toast(s('added', 'Ajouté au panier'));
          return cart;
        });
      })
      .catch(function () { toast(s('cartFailed', 'Connexion au panier impossible')); });
  }

  function changeLine(key, quantity) {
    return fetch(CART_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { toast(s('updateFailed', 'Mise à jour du panier impossible')); });
  }

  /* ---------------- GALERIE PRODUIT ---------------- */
  function selectGalleryIndex(i) {
    var thumbs = $$('[data-gallery-thumb]');
    var main = document.getElementById('pdpMain');
    if (!thumbs.length || !main) return;
    var t = thumbs[i];
    if (!t) return;
    thumbs.forEach(function (x) { x.classList.remove('on'); });
    t.classList.add('on');
    var tpl = t.querySelector('template');
    if (tpl) main.innerHTML = tpl.innerHTML;
  }

  /* ---------------- PAGE PRODUIT ---------------- */
  /*
     Le sélecteur Formule change la CIBLE du formulaire :
       1 coussin, on garde la variante de couleur du produit ;
       un pack, on bascule sur la variante unique du pack.
     Les packs n’ont pas d’option de couleur : le coloris choisi
     part en propriété de ligne, visible sur la commande.
  */
  function initPdp(root) {
    var form = $('[data-product-form]', root || document);
    if (!form || form.getAttribute('data-bound') === 'true') return;
    form.setAttribute('data-bound', 'true');

    var idInput = $('[data-variant-id]', form);
    var colorProp = $('[data-color-property]', form);
    var priceOut = document.getElementById('pdpPrice');
    var colorName = document.getElementById('colorName');
    var packNote = document.getElementById('packNote');
    var addBtn = $('[data-add-button]', form);

    var state = {
      colorVariant: idInput ? idInput.value : null,
      colorLabel: colorName ? colorName.textContent.trim() : '',
      price: parseInt(form.getAttribute('data-base-price'), 10) || 0
    };

    function sync() {
      var packBtn = $('.pack.on', form);
      var isPack = !!packBtn && packBtn.getAttribute('data-pack') !== '1';

      if (idInput) idInput.value = isPack ? packBtn.getAttribute('data-variant-id') : state.colorVariant;

      if (colorProp) {
        colorProp.disabled = !isPack;
        colorProp.value = state.colorLabel;
      }
      if (packNote) packNote.hidden = !isPack;
      if (priceOut) priceOut.textContent = eur(state.price);
    }

    form.addEventListener('click', function (e) {
      var sw = e.target.closest('.swatch');
      if (sw && form.contains(sw)) {
        e.preventDefault();
        if (sw.disabled) return;
        $$('.swatch', form).forEach(function (x) { x.classList.remove('on'); });
        sw.classList.add('on');
        state.colorVariant = sw.getAttribute('data-variant-id');
        state.colorLabel = sw.getAttribute('data-color');
        if (colorName) colorName.textContent = state.colorLabel;
        sync();
        return;
      }
      var pk = e.target.closest('.pack');
      if (pk && form.contains(pk)) {
        e.preventDefault();
        if (pk.disabled) return;
        $$('.pack', form).forEach(function (x) { x.classList.remove('on'); });
        pk.classList.add('on');
        state.price = parseInt(pk.getAttribute('data-price'), 10);
        sync();
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn) addBtn.classList.add('is-loading');
      addToCart(new FormData(form)).then(function () {
        if (addBtn) addBtn.classList.remove('is-loading');
      });
    });

    sync();
  }

  /* ---------------- DÉLÉGATION GLOBALE ---------------- */
  document.addEventListener('click', function (e) {
    var el;

    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); getCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    if (e.target.id === 'ov') { closeCart(); return; }

    if (e.target.closest('[data-mobnav-open]')) {
      e.preventDefault();
      var m = document.getElementById('mobnav');
      if (m) m.classList.add('on');
      return;
    }
    if (e.target.closest('[data-mobnav-close]')) {
      e.preventDefault();
      var mn = document.getElementById('mobnav');
      if (mn) mn.classList.remove('on');
      return;
    }

    if ((el = e.target.closest('[data-rail]'))) {
      e.preventDefault();
      railScroll(el.getAttribute('data-rail'), parseInt(el.getAttribute('data-dir'), 10));
      return;
    }

    if ((el = e.target.closest('.pressure-toggle button'))) {
      var group = el.closest('.pressure');
      $$('.pressure-toggle button', group).forEach(function (x) { x.classList.remove('active'); });
      el.classList.add('active');
      var seat = $('.seat', group);
      if (seat) seat.classList.toggle('on', el.getAttribute('data-seat') === 'on');
      return;
    }

    if ((el = e.target.closest('[data-qty]'))) {
      e.preventDefault();
      var row = el.closest('.line');
      var current = parseInt(row.querySelector('.qty span').textContent, 10) || 0;
      changeLine(el.getAttribute('data-key'), Math.max(0, current + parseInt(el.getAttribute('data-qty'), 10)));
      return;
    }

    if ((el = e.target.closest('[data-gallery-thumb]'))) {
      e.preventDefault();
      selectGalleryIndex($$('[data-gallery-thumb]').indexOf(el));
      return;
    }

    if ((el = e.target.closest('[data-quick-add]'))) {
      e.preventDefault();
      var f = el.closest('form');
      if (f) {
        el.classList.add('is-loading');
        addToCart(new FormData(f)).then(function () { el.classList.remove('is-loading'); });
      }
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
      var m = document.getElementById('mobnav');
      if (m) m.classList.remove('on');
      return;
    }
    if (e.key === 'Enter' || e.key === ' ') {
      var th = e.target.closest && e.target.closest('[data-gallery-thumb]');
      if (th) {
        e.preventDefault();
        selectGalleryIndex($$('[data-gallery-thumb]').indexOf(th));
      }
    }
  });

  /* ---------------- INIT ---------------- */
  function boot() {
    reveal();
    startAnnounce();
    initPdp(document);
    getCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* L’éditeur de thème recharge les sections à chaud : on rebranche. */
  document.addEventListener('shopify:section:load', function (e) {
    reveal();
    startAnnounce();
    initPdp(e.target);
  });
})();
